import { render, staticRenderFns } from "./flowFund.vue?vue&type=template&id=2d18241e&scoped=true"
import script from "./flowFund.vue?vue&type=script&lang=js"
export * from "./flowFund.vue?vue&type=script&lang=js"
import style0 from "./flowFund.vue?vue&type=style&index=0&id=2d18241e&prod&lang=scss&scoped=true"
import style1 from "./flowFund.vue?vue&type=style&index=1&id=2d18241e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d18241e",
  null
  
)

export default component.exports